import React from 'react';
import AsyncSelect from "react-select/async";
import { useAppDispatch } from "../../../app/store";
import { ADMIN_LANG } from "../../../settings";
import { PlainDetails } from "../../../types/admin";
import { getPlainGames } from "../../../app/slices/admin";

interface AsyncGamesSelectProps {
    onChange: (value: PlainDetails[]) => void;
    initialValues: PlainDetails[];
    selectedGames: PlainDetails[];
}

const AsyncGamesSelect = ({ onChange, initialValues, selectedGames }: AsyncGamesSelectProps) => {
    const dispatch = useAppDispatch();

    const loadOptions = (input: string) => {
        return new Promise<PlainDetails[]>((resolve) => {
            if (input.length < 2) {
                return resolve([]);
            }

            dispatch(getPlainGames(input))
                .then((fulfilledAction) => {
                    const data: PlainDetails[] = fulfilledAction.payload.games;
                    resolve(data);
                })
                .catch(() => resolve([]));
        });
    };

    return (
        <AsyncSelect
            value={selectedGames}
            cacheOptions
            defaultOptions={initialValues.length > 0 ? initialValues : undefined}
            isMulti
            loadOptions={loadOptions}
            noOptionsMessage={() => ADMIN_LANG.search}
            onChange={(selectedValues) => onChange(selectedValues as PlainDetails[])}
            placeholder={ADMIN_LANG.select_game}
            classNamePrefix="react-select"
            className="custom-react-select"
        />
    );
};

export default AsyncGamesSelect;
